module.exports = __webpack_public_path__ + "img/huodong_title_chaxie@2x.7b825539.png";